import { getMessage } from './messages'

import getChineseLength from '../utils/getChineseLength'
import isEmpty from '../utils/isEmpty'

const rules = {
  required: msg => value => isEmpty(value) && getMessage('required', { msg }),

  number: msg => value => typeof value !== 'number' && getMessage('number', { msg }),

  string: msg => value => typeof value !== 'string' && getMessage('string', { msg }),

  boolean: msg => value => typeof value !== 'boolean' && getMessage('boolean', { msg }),

  object: msg => value => typeof value !== 'object' && getMessage('object', { msg }),

  array: msg => value => !Array.isArray(value) && getMessage('array', { msg }),

  max: (limit, msg) => value => (value > limit) && getMessage('max', { limit, msg }),

  min: (limit, msg) => value => (value < limit) && getMessage('min', { limit, msg }),

  maxLength: (limit, msg) => value => (value.length > limit) && getMessage('maxLength', { limit, msg }),

  minLength: (limit, msg) => value => (value.length < limit) && getMessage('minLength', { limit, msg }),

  maxChineseLength: (limit, msg) => value => (getChineseLength(value) > limit * 2) && getMessage('maxChineseLength', { limit, msg }),

  minChineseLength: (limit, msg) => value => (getChineseLength(value) < limit * 2) && getMessage('minChineseLength', { limit, msg }),

  url: msg => value => !(/^(https?:|xhsdiscover:)\/\//.test(value)) && getMessage('url', { msg }),
}

rules.list = rules.array

export default rules
